let state = {
    isShowGendu: true,
    isShowWenda: true,
    lastShow: ''  // 上一次到哪个内容了, 包括yuedu gendu wenda 三个
};
export default state;


// WEBPACK FOOTER //
// ./src/vuex/modules/habitLower/state.js